import React from "react";
import Loader from "../../../UI/Loader";
import "../../../../qt-stats.css";

function QTStatComponent({ stats, title, qtfegoal, qtbegoal, qtcancelgoal }) {
  let currencyFormatter = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
  });

  let formatCurrency = (num) => {
    return num ? currencyFormatter.format(num).replace(".00", "") : "$0";
  };

  let now = new Date();
  let quarter = Math.floor(now.getMonth() / 3);
  let firstDate = new Date(now.getFullYear(), quarter * 3, 1);
  let differenceInTime = new Date().getTime() - firstDate.getTime();
  // To calculate the no. of days between two dates
  let differenceInDays = differenceInTime / (1000 * 3600 * 24);
  let coefficient = (differenceInDays * 100) / 90;
  coefficient = coefficient > 100 ? 1 : coefficient / 100;

  return (
    <div className="qt-stats">
      {(!stats || !stats.Stats || Object.keys(stats.Stats).length === 0) && (
        <Loader />
      )}
      {stats && stats.Stats && Object.keys(stats.Stats).length > 0 && (
        <>
          <div className="container sales">
            <div className="card">
              <p
                className={
                  (+stats.Stats.AmountNewSales +
                    +stats.Stats.AmountReactivations +
                    +stats.Stats.AmountReferrals) *
                    coefficient >
                  23400 * coefficient
                    ? "numbers success-color"
                    : "numbers error-color"
                }
              >
                {formatCurrency(
                  +stats.Stats.AmountNewSales +
                    +stats.Stats.AmountReactivations +
                    +stats.Stats.AmountReferrals
                )}
              </p>
              <p className="goal">QT GOAL {formatCurrency(qtfegoal)}</p>
              <span className="title">FrontEnd</span>
              <span className="subtitle">
                (New Sales + Reactivations + Referrals)
              </span>
            </div>
            <div className="card">
              <p
                className={
                  (+stats.Stats.AmountUpsell + +stats.Stats.AmountAdditional) *
                    coefficient >
                  23400 * coefficient
                    ? "numbers success-color"
                    : "numbers error-color"
                }
              >
                {formatCurrency(
                  +stats.Stats.AmountUpsell + +stats.Stats.AmountAdditional
                )}
              </p>
              <p className="goal">QT GOAL {formatCurrency(qtbegoal)}</p>
              <span className="title">BackEnd</span>
              <span className="subtitle">(Upsells and Additional Offices)</span>
            </div>
            <div className="card">
              <p
                className={
                  (+stats.Stats.AmountUpsell +
                    +stats.Stats.AmountNewSales +
                    +stats.Stats.AmountAdditional +
                    +stats.Stats.AmountReactivations +
                    +stats.Stats.AmountReferrals) *
                    coefficient >
                  59400 * coefficient
                    ? "totals sales success-color"
                    : "totals sales error-color"
                }
              >
                {formatCurrency(
                  +stats.Stats.AmountUpsell +
                    +stats.Stats.AmountNewSales +
                    +stats.Stats.AmountAdditional +
                    +stats.Stats.AmountReactivations +
                    +stats.Stats.AmountReferrals
                )}
              </p>
              <p className="goal">
                QT GOAL {formatCurrency(qtfegoal + qtbegoal)}
              </p>
              <span className="subtitle" style={{ marginTop: "20px" }}>
                (Backend + Frontend + Referrals)
              </span>
            </div>
          </div>
          <div className="extra">
            <div className="card" style={{ width: "100%" }}>
              <p className="numbers">
                {Array.from(
                  new Set(
                    Object.keys(stats.QuarterlyFE).concat(
                      Object.keys(stats.QuarterlyBE)
                    )
                  )
                )
                  .reverse()
                  .map((e) => {
                    console.log(e);
                    return (
                      e +
                      ":" +
                      " FE " +
                      formatCurrency(stats.QuarterlyFE[e]) +
                      " / BE " +
                      formatCurrency(stats.QuarterlyBE[e]) +
                      "  |  "
                    );
                  })}
              </p>
            </div>
          </div>
          <div className="container cancellations">
            <div className="card">
              <p
                className={`numbers ${
                  stats.Stats.AmountCancellations * coefficient <
                  12000 * coefficient
                    ? "success-color"
                    : "error-color"
                }`}
              >
                {formatCurrency(stats.Stats.AmountFullCancellations)}
              </p>
              <span className="title">Full GM Cancellations</span>
            </div>
            <div className="card">
              <p
                className={`numbers ${
                  stats.Stats.AmountCancellations * coefficient <
                  12000 * coefficient
                    ? "success-color"
                    : "error-color"
                }`}
              >
                {formatCurrency(stats.Stats.AmountPartialCancellations)}
              </p>
              <span className="title">Cancelled Products</span>
            </div>
            <div className="card">
              <p
                className={
                  stats.Stats.AmountCancellations * coefficient <
                  12000 * coefficient
                    ? "totals success-color"
                    : "totals error-color"
                }
              >
                {formatCurrency(stats.Stats.AmountCancellations)}
              </p>
              <p className="goal">
                QT GOAL &gt; {formatCurrency(qtcancelgoal)}
              </p>
              <span className="title" style={{ display: "block" }}>
                Total Lost
              </span>
            </div>
          </div>
          <div className="extra">
            <div className="card" style={{ width: "100%" }}>
              <p className="numbers">
                {Array.from(
                  new Set(
                    Object.keys(stats.QuarterlyCancelledGMs).concat(
                      Object.keys(stats.QuarterlyCancelledProds)
                    )
                  )
                )
                  .reverse()
                  .map((e) => {
                    console.log(e);
                    return (
                      e +
                      ":" +
                      " FULL MEMBERSHIPS " +
                      formatCurrency(stats.QuarterlyCancelledGMs[e]) +
                      " / PRODS " +
                      formatCurrency(stats.QuarterlyCancelledProds[e]) +
                      "  |  "
                    );
                  })}
              </p>
            </div>
          </div>
          <div className="container net">
            <div className="card" style={{ padding: "10px" }}>
              <div
                style={{
                  width: "100%",
                  height: "100%",
                  paddingTop: "40px",
                  paddingBottom: "40px",
                }}
              >
                <p className="numbers" style={{ marginTop: "0" }}>
                  {formatCurrency(+stats.Stats.AmountRefunds)}
                </p>
                <p className="title" style={{ marginTop: "-10px" }}>
                  Refunds
                </p>
              </div>
            </div>
            <div className="card" style={{ marginRight: "20px" }}>
              <div
                style={{
                  width: "100%",
                  height: "100%",
                  paddingTop: "40px",
                  paddingBottom: "40px",
                }}
              >
                <p className="numbers" style={{ marginTop: "0" }}>
                  {formatCurrency(+stats.Stats.AmountCredits)}
                </p>
                <p className="title" style={{ marginTop: "-10px" }}>
                  Credits
                </p>
              </div>
            </div>
            <div className="card" style={{ marginTop: "-20px" }}>
              <p
                className={`totals ${
                  (+stats.Stats.AmountUpsell +
                    +stats.Stats.AmountNewSales +
                    +stats.Stats.AmountAdditional +
                    +stats.Stats.AmountReactivations +
                    +stats.Stats.AmountReferrals -
                    +stats.Stats.AmountCancellations) *
                    coefficient >
                  47400 * coefficient
                    ? "success-color"
                    : "error-color"
                }`}
              >
                {formatCurrency(
                  +stats.Stats.AmountUpsell +
                    +stats.Stats.AmountNewSales +
                    +stats.Stats.AmountAdditional +
                    +stats.Stats.AmountReactivations +
                    +stats.Stats.AmountReferrals -
                    +stats.Stats.AmountCancellations
                )}
              </p>
              <p className="title">
                QT GROWTH {formatCurrency(qtfegoal + qtbegoal - qtcancelgoal)}
              </p>
            </div>
          </div>
          <div className="extra">
            <div className="card" style={{ width: "100%" }}>
              <p className="numbers">
                {Array.from(
                  new Set(
                    Object.keys(stats.QuarterlyRefunds).concat(
                      Object.keys(stats.QuarterlyCredits)
                    )
                  )
                )
                  .reverse()
                  .map((e) => {
                    console.log(e);
                    return (
                      e +
                      ":" +
                      " Refunds " +
                      formatCurrency(stats.QuarterlyRefunds[e]) +
                      " / Credits " +
                      formatCurrency(stats.QuarterlyCredits[e]) +
                      "  |  "
                    );
                  })}
              </p>
            </div>
          </div>
        </>
      )}
    </div>
  );
}

export default QTStatComponent;
